/**
 * 録音 Blob → 品質判定の標準パイプライン。
 *
 * @graph-stack voice-enrollment
 * @graph-domain Engineering
 * @graph-business decodeAudioBlob → computeQualityMetrics → evaluateQuality を直列に繋いで verdict を返す
 * @graph-connects decodeAudioBlob [calls] PCM 化
 * @graph-connects evaluateQuality [calls] 閾値判定
 */

import { computeQualityMetrics, evaluateQuality, type QualityVerdict } from './audio-quality.js';
import { decodeAudioBlob } from './decode-audio.js';

/**
 * @graph-stack voice-enrollment
 * @graph-domain Engineering
 * @graph-business 録音 Blob を PCM 化 → 品質メトリクス計算 → 閾値判定までを実行する標準パイプライン
 * @graph-connects decodeAudioBlob [calls] PCM 化
 * @graph-connects evaluateQuality [calls] 閾値判定
 */
export async function runDefaultQualityCheck(blob: Blob): Promise<QualityVerdict> {
  const decoded = await decodeAudioBlob(blob);
  const metrics = computeQualityMetrics(decoded.samples, decoded.sampleRate);
  return evaluateQuality(metrics);
}
